import { createSelector } from 'reselect';

import { getCalculatedImpoundFields } from 'utils/impounds';

import { selectImpoundTypes } from 'store/system/selectors';

import { selectLoanApplication } from './loanApplication.selectors';

const selectImpounds = createSelector(selectLoanApplication, ({ impounds }) => impounds);

export const selectExtendedImpounds = createSelector(
  [selectImpounds, selectImpoundTypes],
  (impoundsData, impoundsTypes) => {
    const impounds = (impoundsData.impounds || []).map(impound => {
      const { impoundTypeId } = impound;
      const { monthlyAmount, collectedAmount } = getCalculatedImpoundFields(impound);

      const impoundTypeName = impoundsTypes[impoundTypeId]?.name;

      return {
        ...impound,
        monthlyAmount,
        collectedAmount,
        impoundTypeName,
      };
    });

    const total =
      (impoundsData.aggregateAdjustment || 0) +
      impounds.reduce((sum, { collectedAmount }) => sum + collectedAmount, 0);

    return {
      ...impoundsData,
      total,
      impounds,
    };
  },
);
